import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Input, LegacyForm, Space, Typography } from "@payping/web-components";
import { DashboardChecksTypeEnum } from "@payping/api";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Business/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";
import { Trans } from "@payping/utils/localeUtils";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessEconomicCode: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isBusinessDisabled = checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const economicCodeApi = useAppSelector((state) => state.user.businessInfo?.economicCode);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.economicCode")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
        footer={<EditActionButtons onAccept={form.submit} acceptText={t("next")} />}
      >
        <Space orientation={"vertical"}>
          <LegacyForm
            onFinish={({ economicCode }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.officialBusinessDocument.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessDocument.url,
                fieldName: "economicCode",
                fieldValue: economicCode,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ economicCode: mobileFormEditState.economicCode ?? economicCodeApi }}
          >
            <LegacyForm.Item label={t("settings.business.economicCode")} name="economicCode">
              <Input disabled={!form.getFieldValue("economicCode") ? false : isBusinessDisabled} />
            </LegacyForm.Item>
          </LegacyForm>
          <Typography.Text className="tw:whitespace-pre-line" type={"secondary"}>
            <Trans
              i18nKey={"mobileEditPersonal.nameDesc"}
              components={[
                <Typography.Link
                  key={0}
                  href={"https://irsherkat.ssaa.ir/Design/SearchCompanyPublicInfo.aspx"}
                  target="_blank"
                />,
              ]}
            />
          </Typography.Text>
        </Space>
      </Drawer>
    </>
  );
};

export default MobileEditOfficialBusinessEconomicCode;
